import { OnInit, Input, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-dynamic-column',
  template: '<span>{{ text }}</span>',
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class DynamcColumnComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: any;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // Contiene el valor a mostrar
  text: any;

  ngOnInit() {
    this.text = this.generateFormatText(this.value);
  }

  /**
   * Genera el formato de el dato de la columna dependiendo de su tipo
   *
   * @private
   * @param {*} data
   * @returns {string}
   * @memberof DynamcColumnComponent
   */
  private generateFormatText(data: any): string {
    let val = '';
    const moment = require('moment');
    let date = false;
    if (!Number(data)) {
      if (data &&  moment(String(data)).isValid()) {
        date = true;
      } else {
        date = false;
      }
    } else {
      date = false;
    }
    if (!date) {
      if (typeof data === 'boolean') {
        if (data) {
          val = 'Sí';
        } else {
          val = 'No';
        }
      } else if (Array.isArray(data)) {
        if (data.length) {
          data.forEach((dt, index) => {
            val += this.generateFormatText(dt);
            val += '; ';
          });
        }
      } else {
        val = data;
      }
    } else {
      let formatDate = 'DD/MM/YYYY';
      if (this.rowData['formato_fecha']) {
        formatDate = this.rowData['formato_fecha'];
      }
      val = moment(String(data)).format(formatDate);
    }
    return val;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/dynamic-column.component.ts